"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _text = require("@mmc/text");

var propTypes = {
  modelSelectorData: _propTypes["default"].shape({
    vehicleName: _propTypes["default"].string,
    paymentCalculatorLabel: _propTypes["default"].string,
    msrpLabel: _propTypes["default"].string,
    msrpDisclaimerNo: _propTypes["default"].string,
    ctaText: _propTypes["default"].string,
    ctaUrl: _propTypes["default"].string,
    vehicles: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      modelName: _propTypes["default"].string,
      msrpValueDisplay: _propTypes["default"].string,
      imageAltText: _propTypes["default"].string,
      imagePath: _propTypes["default"].string,
      keyFeatures: _propTypes["default"].arrayOf(_propTypes["default"].string)
    })),
    hideKeyFeatures: _propTypes["default"].bool,
    addPriceDisclaimer: _propTypes["default"].bool,
    priceDisclaimerId: _propTypes["default"].string,
    disclaimerData: _text.disclaimerDataPropTypes
  })
}; // eslint-disable-next-line import/prefer-default-export

exports.propTypes = propTypes;